function initBetulaFaqSearch() {
  const search = document.getElementById('betulaFaqSearch');
  if (!search || search.dataset.searchReady === 'true') return;

  search.dataset.searchReady = 'true';

  search.addEventListener('input', function () {
    const q = this.value.toLowerCase().trim();

    document.querySelectorAll('.betula-faq details').forEach(function (item) {
      const text = (
        item.textContent + ' ' + (item.dataset.keywords || '')
      ).toLowerCase();

      item.style.display = text.includes(q) ? '' : 'none';
    });

    document.querySelectorAll('.betula-faq h2').forEach(function (heading) {
      let item = heading.nextElementSibling;
      let hasVisibleQuestion = false;

      while (item && item.tagName === 'DETAILS') {
        if (item.style.display !== 'none') {
          hasVisibleQuestion = true;
        }
        item = item.nextElementSibling;
      }

      heading.style.display = hasVisibleQuestion ? '' : 'none';
    });
  });
}

document.addEventListener('DOMContentLoaded', initBetulaFaqSearch);
document.addEventListener('shopify:section:load', initBetulaFaqSearch);